<script setup lang="ts">
import type { RichTextStoryblok } from "#storyblok-components";

const props = defineProps<{ blok: RichTextStoryblok }>();
const richTextContent = computed(() => props.blok.content);
</script>

<template>
  <div
    v-editable="blok"
    class="block-viewport-container"
  >
    <StoryblokRichText :doc="richTextContent" />
  </div>
</template>

<style lang="postcss" scoped>
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "platform-font", "mwsDefaultFont", "mwsDefaultFont fallback";
  @apply uppercase;
}

/* creating some reasonable generic styling for the injected html */
/* using :deep so that the styles apply to the injected html */
:deep(h1) {
  @apply text-4xl;
  @apply py-6;
  @apply font-black;
  @apply uppercase;
}
:deep(h2) {
  @apply text-3xl;
  @apply py-3;
  @apply font-black;
  @apply uppercase;
}
:deep(h3) {
  @apply text-2xl;
  @apply py-2;
  @apply font-bold;
}
:deep(h4) {
  @apply text-xl;
  @apply font-bold;
}
:deep(h5) {
  @apply text-lg;
  @apply font-bold;
}
:deep(h6) {
  @apply text-lg;
}

:deep(a) {
  @apply underline;
}

:deep(ul) {
  > li {
    margin-left: 2em;
    list-style-type: disc;
  }
}

:deep(p) {
  @apply [&:not(:first-child)]:pt-4;
}

:deep(table) {
  @apply w-full;
  @apply border-collapse;
  @apply py-4;

  th,
  td {
    @apply border;
    @apply p-2;
    @apply text-left;
  }

  th {
    @apply font-bold;
  }
}
</style>
